<template>
	<div>
		<PageHeaderLayout>
			<div class="main-page-content">
				<el-row class="table-search">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item v-for="item in searchList" :key="item.props" :label="item.label">
							<el-input
								v-if="item.type === 'input'"
								v-model="searchCondition[item.props]"
								:placeholder="'请输入' + item.label"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
						</el-form-item>
					</el-form>
				</el-row>
				<ApeTable
					ref="apeTable"
					:data="tableData"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				>
					<el-table-column label="操作" width="100" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="goDetails(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import { search_list, tableColumns } from './config/registrationRecord.ts'

export default {
	name: 'RegistrationRecord',
	components: {
		PageHeaderLayout,
		ApeTable
	},
	data() {
		return {
			searchCondition: {},
			searchList: search_list,
			columns: tableColumns,
			loadingStaus: true,
			tableData: [],
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			}
		}
	},
	methods: {
		searchButton() {
			this.initList('search')
		},
		switchPaging() {
			this.initList()
		},
		formatList(list) {
			const statusMap = { 0: '未开始', 1: '进行中', 2: '已结束' }
			return list.map(item => ({
				...item,
				course_time_text: [item.startTime, item.endTime].filter(Boolean).join(' 至 '),
				status_text: statusMap[item.status] || '-'
			}))
		},
		async initList(type) {
			this.loadingStaus = true
			const pagingInfo = this.$refs.apeTable.getPagingInfo(type)
			if (type === 'search') {
				pagingInfo.current_page = 1
			}
			try {
				const res = await this.$api.getCourseList({
					...this.searchCondition,
					...pagingInfo
				})
				const list = res.data || res.list || []
				const pages = res.pages || { total: res.total || 0, offset: res.offset || 0 }
				this.tableData = this.formatList(list)
				this.pagingData.total = pages.total || 0
				this.pagingData.offset = pages.offset || 0
			} catch (e) {
				this.tableData = []
				this.$message.error(e.message || '获取报名记录失败')
			}
			this.loadingStaus = false
		},
		goDetails(row) {
			this.$router.push({ path: '/manager/registrationDetails', query: { id: row.id } })
		}
	},
	mounted() {
		this.initList()
	}
}
</script>

<style lang="scss" scoped>
.table-search {
	margin-bottom: 16px;
}
</style>
